import { RouteObject } from 'react-router-dom';
import { FeatureSliderManager } from './employers-managment/feature-slider-manager';
import { FeaturePlansManager } from './configurations/feature-plans-manager';
import { FeatureBlogsManager } from './blogs-managment/feature-blogs-manager';
import { FeatureResumeManager, FeatureSimpleResumeManager } from './resume-managment';
import { SimpleResumeEdit } from './resume-managment/feature-simple-resume-edit';
import { FeaturePlanEdit } from './configurations/feature-plan-edit';
import { FeatureEditCandidateProfile } from './candidates-managment/feature-edit-candidate-profile';
import { FeatureMainAnalytics } from './feature-main-analytics';

export const ADMIN_ROUTES: RouteObject[] = [
   {
      path: '/admin/admins/dashboard',
      Component: FeatureMainAnalytics,
   },
   {
      path: '/admin/users/selectforslider',
      Component: FeatureSliderManager,
   },
   {
      path: '/admin/manage-plans',
      Component: FeaturePlansManager,
   },
   {
      path: '/admin/blogs',
      Component: FeatureBlogsManager,
   },
   {
      path: '/admin/simple-resumes',
      Component: FeatureSimpleResumeManager,
   },
   {
      path: '/admin/resumes',
      Component: FeatureResumeManager,
   },
   {
      path: '/admin/simple-resumes/:id/edit',
      Component: SimpleResumeEdit,
   },
   {
      path: '/admin/plan/:slug/edit',
      Component: FeaturePlanEdit,
   },
   {
      path: '/admin/plan/:slug/edit',
      Component: FeaturePlanEdit,
   },
   {
      path: '/admin/candidates/editcandidates/:slug',
      Component: FeatureEditCandidateProfile,
   },
];
